<template>
  <VueSelect
    :options="landings"
    :v-model="model"
    :name="name"
    :label="label"
    :is-required="true"
    :target-property="targetProperty"
    :lib-options="{
      placeholder,
      loading,
    }"
  />
</template>

<script>
import { mapState } from 'vuex';
import debounce from 'lodash/debounce';
import VueSelect from './VueSelect.vue';
import commonProperties from './common-properties';

export default {
  name: 'SelectLandingPageId',
  components: {
    VueSelect,
  },
  mixins: [commonProperties],
  inheritAttrs: false,
  data() {
    return {
      landings: [],
      loading: false,
    };
  },
  computed: {
    landingsHaveBeenLoaded() {
      return this.landings.length > 0;
    },
    hasLetsbookApiId() {
      return !!this.customerSettings.letsbookApiId;
    },
    placeholder() {
      if (!this.hasLetsbookApiId) {
        return 'Antes, insira o ID do Letsbook acima';
      }

      if (this.landings.length === 0 && !this.loading) {
        return 'ID do Letsbook não encontrada';
      }

      return '';
    },
    ...mapState(['customerSettings', 'apiData']),
  },
  watch: {
    'customerSettings.letsbookApiId': debounce(function loadLandings() {
      this.model = null;
      this.requestIdLandings();
    }, 1000),
  },
  beforeMount() {
    if (this.hasLetsbookApiId) {
      this.requestIdLandings();
    }
  },
  methods: {
    async requestIdLandings() {
      if (!this.customerSettings.letsbookApiId) {
        return;
      }

      this.loading = true;
      const url = `${this.customerSettings.letsbookApiId}/landings`;

      if (!this.apiData[url]) {
        try {
          await this.$store.dispatch('loadApiData', url);
        } catch {
          this.loading = false;
          this.landings = [];
          return;
        }
      }

      const landings = this.apiData[url];
      this.landings = this.landingsToOptions(landings);

      if (this.landings.length > 0 && !this.model) {
        this.model = this.landings[0].value;
      }

      this.loading = false;
    },
    landingsToOptions(landings) {
      const options = landings.map((landing) => ({
        label: landing.Descricao,
        value: landing.CodLanding,
      }));

      return options;
    },
  },
};
</script>

<style scoped lang="scss">
h3 {
  font-weight: $lb-medium;
  font-size: $size-normal;
  line-height: 1.5;
  color: $dark;
}
</style>
